import { Box, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useTheme } from "@emotion/react";
import Spinner from "../Spinner";

const DashboardWrapper = ({ children, loading, heading }) => {
  const theme = useTheme();
  const mdScreen = useMediaQuery(theme.breakpoints.down("md"));
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    setCollapse(mdScreen);
  }, [mdScreen]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={{
        xs: "calc(100% - 80px)",
        md: "calc(100% - 260px)",
      }}
      padding={{ xs: "1rem", md: "1rem 1.5rem" }}
      height="100vh"
      boxSizing="border-box"
    >
      {loading && <Spinner />}
      <Box
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <Header
          heading={heading}
          mdScreen={mdScreen}
          smScreen={smScreen}
          collapse={collapse}
        />
        <Box
          sx={{
            width: "100%",
            height: "calc(100% - 44px)",
            boxSizing: "border-box",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardWrapper;
